import React from "react";
import AppRoutes from "./routes/Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { Box } from "@mui/material";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <AuthProvider>
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "#f7f8f9", // Fond gris très clair pour faire ressortir le blanc
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Le Header et le SideMenu sont appelés à l'intérieur de AppRoutes 
            ou directement dans tes pages de Dashboard pour plus de flexibilité */}
        
        <AppRoutes />

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Box>
    </AuthProvider>
  );
}

export default App;